import React, { useEffect, useMemo, useState } from "react";
// import LightTable from "../../components/components-bootstrap/LightTable";
import { useGetFetch } from "../../data/Queries";
import {
  gymDashBoardReportsGet,
  gymDashBoardReportsGetKey,
  gymsGet,
  gymsGetKey,
} from "../../data/ApiEndpoints";
import { useSelector } from "react-redux";
import { selectAuth, selectToken } from "../../components/auth/auth.selector";
// import PaginationLight from "../../components/components-bootstrap/PaginationLight";
import Loader from "../../components/ui/Loader";
import { formatNumber } from "../../utils/utilityfunc";
import FilterBlock from "../../components/FilterBlock";
import DateRanger from "../../components/components-react/DateRanger";
import { CSVLink } from "react-csv";
import { format, addDays } from "date-fns";
import moment from "moment";
import "../../styles/exports/exports-global.css";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
import {
  convertThenFormat,
  convertUnixTimestampToDate,
  formatDateTimezon,
} from "../../components/common-data/Converts";
import HelmetWrapper from "../../HelmetWrapper";

const SalesExportPage = () => {
  const cols = [
    // "subscription_id",
    "payment_mode",
    "price",
    "taxable_value",
    "taxable_rate",
    "integrated tax",
    "central tax",
    "state tax",
    "receiver name",
    "mobile",
    "nature_of_service",
    "gym_name",
  ];
  const token = useSelector(selectToken);
  const userInfo = useSelector(selectAuth);
  const { user } = userInfo || {};
  const isAdmin = user?.account_type === "admin";

  // Check if user is a manager role (cluster_manager, fitness_manager, sales_manager, club_manager)
  const isManagerRole = ["cluster_manager", "fitness_manager", "sales_manager", "club_manager"].includes(user?.account_type);

  const [csvData, setcsvData] = useState([cols]);
  const initalStartandenddateValues = {
    startDate: "",
    endDate: "",
    selectedDates: "",
    selectedDate: "",
  };
  const [startAndEndDate, setStartAndEndDate] = useState(
    initalStartandenddateValues
  );

  const [dateRangerOpen, setDateRangerOpen] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);

  const [filters, setFilters] = useState({
    filter_type: "today",
    limit: "10",
    // For manager roles, don't pass gym_id - backend will automatically filter by assigned gyms
    // For non-admin, non-manager users, pass their gym_id
    gym_id: isManagerRole ? "" : (!isAdmin ? user?.gym_id || user?.uid : ""),
  });
  const [isPage, setIsPage] = useState(0);
  const {
    data: reportsData,
    isLoading: isLoadingReports,
    isFetching: isFetchingReports,
    refetch: refetchReports,
  } = useGetFetch({
    url: gymDashBoardReportsGet,
    key: gymDashBoardReportsGetKey,
    token,
    filters,
    isPage: isPage + 1,
  });

  const {
    data: gymsData,
    isLoading: isLoadingGyms,
    isFetching: isFetchingGyms,
  } = useGetFetch({
    url: gymsGet,
    key: gymsGetKey,
    token,
  });

  const gymOpt = useMemo(() => {
    try {
      if (gymsData) {
        const { data, status } = gymsData;
        if (status) {
          const res =
            data &&
            data.map((gym) => {
              return {
                label: gym?.gym_name,
                value: gym?.user_id,
              };
            });
          return res;
        }
      }
      return [];
    } catch (error) {
      console.log(error);
    }
  }, [gymsData]);

  function calculateGST(sellingPrice, gstRate = 18, decimal = 2) {
    if (isNaN(sellingPrice) || isNaN(gstRate)) {
      return {
        error: "Invalid input. Selling price and GST rate must be numbers.",
      };
    }

    const taxableValue = sellingPrice / (1 + gstRate / 100);

    const cgst = (taxableValue * gstRate) / 200;
    const sgst = cgst;
    const igst = (taxableValue * gstRate) / 100;
    const totalAmount = sellingPrice;

    return {
      taxableValue: taxableValue.toFixed(decimal),
      cgst: cgst.toFixed(decimal),
      sgst: sgst.toFixed(decimal),
      igst: igst.toFixed(decimal),
      totalAmount: totalAmount.toFixed(decimal),
    };
  }

  function handleClearRangeDate() {
    try {
      setRangeState(initialRangeState);
      setStartAndEndDate({
        ...startAndEndDate,
        startDate: "",
        endDate: "",
        selectedDates: "",
      });
      setDateRangerOpen(false);
    } catch (error) {
      console.log(error);
    }
  }

  const allFilters = [
    {
      id: 0,
      label: "Gym",
      name: "gym_id",
      options: gymOpt,
    },
    {
      id: 1,
      label: "Select Range",
      elemnt: (
        <div>
          <div className="flex-k sales-export-dateranger">
            {dateRangerOpen ? (
              <div className="flex-k w-full-k h-full-k mt-2 gap-1-k js-end-k">
                <button
                  onClick={() => setDateRangerOpen(false)}
                  className="btn-k btn-primary-k small"
                >
                  Close
                </button>
                <button
                  className="btn-k btn-primary-k small"
                  onClick={handleClearRangeDate}
                >
                  Clear
                </button>
              </div>
            ) : startAndEndDate?.selectedDates ? (
              <button
                onClick={() => {
                  setDateRangerOpen(true);
                }}
                className="btn-k btn-primary-k w-full-k"
              >
                {startAndEndDate.selectedDates}
              </button>
            ) : (
              <button
                onClick={() => {
                  setDateRangerOpen(true);
                }}
                className="btn-k btn-primary-k w-full-k"
              >
                Select Date Range
              </button>
            )}
          </div>
          {dateRangerOpen && (
            <div className="date-ranger-k sales-export-dateranger-k">
              <DateRanger
                handleDateRangeChange={handleDateRangeChange}
                rangeState={rangeState}
                onClose={() => setDateRangerOpen(false)}
                onClear={handleClearRangeDate}
                closeRanger={() => {
                  setDateRangerOpen(false);
                }}
              />
            </div>
          )}
        </div>
      ),
    },
  ];

  function handleDateRangeChange(item) {
    try {
      setRangeState([item?.selection]);

      const formattedStartDate = format(
        item?.selection?.startDate,
        "yyyy-MM-dd"
      );
      const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

      const formattedStart = moment(formattedStartDate).tz("Asia/Kolkata").format("DD-MM-YYYY");
      const formattedEnd = moment(formattedEndDate).tz("Asia/Kolkata").format("DD-MM-YYYY");

      setStartAndEndDate({
        ...startAndEndDate,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        selectedDates: `${formattedStart} to ${formattedEnd}`,
      });
    } catch (error) {
      console.log(error);
    }
  }

  function getMode(data) {
    try {
      const map = {
        cash: "cash",
        "cash/online": "online/cash",
      };

      return map[data] ? map[data] : "online";
    } catch (error) {
      console.log(error);
    }
  }

  function handleSetFilters(filters) {
    try {
      setFilters({
        ...filters,
        filter_type: "today",
        start_date: startAndEndDate?.startDate,
        end_date: startAndEndDate?.endDate,
      });
    } catch (error) {
      console.log(error);
    }
  }

  function isLoading() {
    try {
      if (isLoadingReports || isFetchingReports) {
        return true;
      }
      if (isLoadingGyms || isFetchingGyms) {
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
    }
  }

  function getFormattedData(data) {
    try {
      const res = [];
      data &&
        data.forEach((item) => {
          const taxes = calculateGST(item?.price, 18, 4);
          const row = {
            [cols[0]]: item?.subscription_id,
            [cols[1]]: getMode(item?.trx_id),
            [cols[2]]: item?.price,
            [cols[3]]: taxes?.taxableValue,
            [cols[4]]: "18",
            [cols[5]]: taxes?.igst,
            [cols[6]]: taxes?.cgst,
            [cols[7]]: taxes?.sgst,
            [cols[8]]: item?.name || "",
            [cols[9]]: item?.mobile,
            [cols[10]]: item?.plan_name || item?.addon_name,
            [cols[11]]: item?.gym_name,
          };
          res.push(row);
        });
      return res;
    } catch (error) {
      console.log(error);
    }
  }

  function isData() {
    try {
      if (
        !reportsData ||
        !reportsData?.data ||
        !reportsData?.data?.fullPayments ||
        !reportsData?.data?.fullPayments?.length
      ) {
        return false;
      }
      return true;
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    try {
      refetchReports();
    } catch (error) {
      console.log(error);
    }
  }, [filters]);

  useEffect(() => {
    try {
      const formattedData = getFormattedData(
        reportsData?.data?.fullPayments || []
      );
      setcsvData(formattedData);
    } catch (error) {
      console.log(error);
    }
  }, [reportsData?.data?.fullPayments]);

  const columns1 = [
    {
      dataField: "trx_id",
      text: "Payment Mode",
      formatter: (data) => (
        <div className="flex-k js-center-k items-center-k">
          <span className="fs-small-k capitalise-k">
            {getMode(data) || "N/A"}
          </span>
        </div>
      ),
    },
    {
      dataField: "price",
      text: "Price",
      formatter: (_, row) => (
        <div className="flex-k js-center-k w-8rem-k items-center-k">
          <span className="fs-small-k">
            {!isNaN(row?.price) ? `₹ ${formatNumber(row?.price)}` : "N/A"}
          </span>
        </div>
      ),
    },
    {
      dataField: "",
      text: "Taxable Value",
      formatter: (_, row) => (
        <div className="flex-k js-center-k items-center-k">
          <span className="fs-small-k">
            {calculateGST(row?.price)?.taxableValue || "N/A"}
          </span>
        </div>
      ),
    },
    {
      dataField: "",
      text: "Taxable Rate",
      formatter: (_, row) => (
        <div className="flex-k js-center-k items-center-k">
          <span className="fs-small-k">{"18%" || "N/A"}</span>
        </div>
      ),
    },
    {
      dataField: "",
      text: "Integrated Tax",
      formatter: (_, row) => (
        <div className="flex-k js-center-k items-center-k">
          <span className="fs-small-k">
            {calculateGST(row?.price).igst || "N/A"}
          </span>
        </div>
      ),
    },
    {
      dataField: "",
      text: "Central Tax",
      formatter: (_, row) => (
        <div className="flex-k js-center-k items-center-k">
          <span className="fs-small-k">
            {calculateGST(row?.price)?.cgst || "N/A"}
          </span>
        </div>
      ),
    },
    {
      dataField: "",
      text: "State Tax",
      formatter: (_, row) => (
        <div className="flex-k js-center-k items-center-k">
          <span className="fs-small-k">
            {calculateGST(row?.price).sgst || "N/A"}
          </span>
        </div>
      ),
    },
    {
      dataField: "name",
      text: "Receiver Name",
      formatter: (data) => (
        <div className="flex-k js-center-k items-center-k">
          <span className="fs-small-k">{data || "N/A"}</span>
        </div>
      ),
    },
    {
      dataField: "mobile",
      text: "Mobile",
      formatter: (data) => (
        <div className="flex-k js-center-k items-center-k">
          <span className="fs-small-k">{data || "N/A"}</span>
        </div>
      ),
    },
    {
      dataField: "plan_name",
      text: "Nature of Service",
      formatter: (_, row) => (
        <div className="flex-k js-center-k items-center-k">
          <span className="fs-small-k">
            {row?.plan_name || row?.addon_name || "N/A"}
          </span>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (data) => (
        <div className="flex-k js-center-k items-center-k">
          <span className="fs-small-k">{data || "N/A"}</span>
        </div>
      ),
    },
  ];

  const columns = [
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "name",
      text: "Receiver",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150 bold">
            {row?.name || "NA"}
            <br />
            <small style={{ fontWeight: "500" }}>{row?.mobile || ""}</small>
          </span>
        );
      },
    },
    {
      dataField: "type",
      text: "Nature of Service",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150 bold">
            {row?.type === "regular"
              ? row?.plan_name || "NA"
              : row?.addon_name?.replace(/_/g, " ") || "NA"}
            <br />
            <small style={{ fontWeight: "500" }}>
              (
              {row?.type === "addon_pt"
                ? "PT"
                : row?.type?.replace(/_/g, " ") || ""}
              )
            </small>
          </span>
        );
      },
    },
    {
      dataField: "price",
      text: "Price",
      formatter: (cell, row) => {
        return (
          <span className="tb-data bold">
            ₹{formatNumber(row?.price || 0)}
            <br />
            <small style={{ fontWeight: "500" }}>
              ({row?.trx_id ? getMode(row.trx_id) : ""})
            </small>
          </span>
        );
      },
    },
    {
      dataField: "price",
      text: "Taxable Value",
      formatter: (cell, row) => {
        const taxes = calculateGST(row?.price, 18, 4);

        return (
          <span className="tb-data minWidth150">
            ₹{convertThenFormat(taxes?.taxableValue || 0)} (18%)
          </span>
        );
      },
    },
    {
      dataField: "price",
      text: "Integrated Tax",
      formatter: (cell, row) => {
        const taxes = calculateGST(row?.price, 18, 4);

        return (
          <span className="tb-data">
            ₹{convertThenFormat(taxes?.igst || 0)}
          </span>
        );
      },
    },
    {
      dataField: "price",
      text: "Central Tax",
      formatter: (cell, row) => {
        const taxes = calculateGST(row?.price, 18, 4);

        return (
          <span className="tb-data">
            ₹{convertThenFormat(taxes?.cgst || 0)}
          </span>
        );
      },
    },
    {
      dataField: "price",
      text: "State Tax",
      formatter: (cell, row) => {
        const taxes = calculateGST(row?.price, 18, 4);

        return (
          <span className="tb-data">
            ₹{convertThenFormat(taxes?.sgst || 0)}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Membership Start Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? convertUnixTimestampToDate(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "expire_date",
      text: "Membership Expire Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
          </span>
        );
      },
    },
    // {
    //   dataField: "trx_id",
    //   text: "Payment Mode",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data">
    //         {row?.trx_id ? getMode(row.trx_id) : "NA"}
    //       </span>
    //     );
    //   },
    // },
  ];

  return (
    <HelmetWrapper title="WTF: Sales Export">
      <div className="cloud-bg-k">
        <div className="container-k h-screen-k">
          <section className="flex-k py-1 js-between-k">
            <span className="bold-text fs-med-k m-0">Sales Data</span>
            <CSVLink
              download={"sales_data.csv"}
              className="btn-k small btn-primary-k"
              data={csvData}
            >
              Export CSV
            </CSVLink>
          </section>
          <FilterBlock allFilters={allFilters} setFilters={handleSetFilters} />
          {isLoading() ? (
            <div>
              <Loader />
            </div>
          ) : (
            <>
              <div className="fullWidthFlexCenter separatedTable mt30">
                <PaymentLinkTable
                  tableData={
                    (reportsData?.data && reportsData?.data?.fullPayments) || []
                  }
                  tableColumns={columns}
                />
              </div>
              {/* <LightTable
              data={
                (reportsData?.data && reportsData?.data?.fullPayments) || []
              }
              columns={columns}
            /> */}
              {!isData() ? (
                <div className="flex-k js-center-k my-4-k w-full-k">
                  <span>
                    {startAndEndDate?.startDate && filters?.start_date
                      ? "No Data Found For Selected Date!"
                      : "Select Date!"}
                  </span>
                </div>
              ) : null}
              {/* <PaginationLight
              isPage={isPage}
              onChangePage={setIsPage}
              pagination={reportsData?.pagination || []}
            /> */}
            </>
          )}
        </div>
      </div>
    </HelmetWrapper>
  );
};

export default SalesExportPage;
